import type {ComponentType, ReactElement} from 'react';
import React from 'react';
import type {StreamComponentRegistration, StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

/**
 * Build a stream-component registration from its type, component, and a props guard.
 * Removes the repeated `render: (props) => React.createElement(Component, props)` shim and
 * object shape from every widget's registration — each only supplies its parseProps guard.
 */
export function defineStreamComponentRegistration<TComponentType extends StreamComponentType, TProps extends object>(
  componentType: TComponentType,
  component: ComponentType<TProps>,
  parseProps: (props: Record<string, unknown>) => TProps | null
): StreamComponentRegistration<TComponentType, TProps> {
  return {
    componentType,
    parseProps,
    render: (props: TProps): ReactElement => React.createElement(component, props),
  };
}
